exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nh1[data-v-919c2988],\nh2[data-v-919c2988] {\n\tfont-weight: normal;\n}\nul[data-v-919c2988] {\n\tlist-style-type: none;\n\tpadding: 0;\n}\nli[data-v-919c2988] {\n\tdisplay: inline-block;\n\tmargin: 0 10px;\n}\na[data-v-919c2988] {\n\tcolor: #42b983;\n}\n.btn-lg[data-v-919c2988] {\n\twidth: 100%;\n}\n", ""]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-919c2988","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/User/Signin.vue
// module id = SpsX
// module chunks = 1